export enum FileSize {
    _1MB = 1048576,
    _5MB = 5242880,
    _10MB = 10485760,
}
